import { get as lodashGet } from 'lodash';

import { buildURL, urls } from '../../../helpers/urls';
import { handleResponse, patch } from '../../../helpers/fetch';
import store from '../../../store';

export const updateEventOverlays = (event) => {
  const url = buildURL(urls.events.root, 'overlays');
  return patch(url, event);
};

/**
 * POST animated WebP + video for an existing overlay
 */
export const uploadOverlayAnimationMedia = async (slugDate, storageKey, webpFile, videoFile) => {
  const url = buildURL(
    urls.events.root,
    slugDate,
    'overlays',
    encodeURIComponent(storageKey),
    'animation-media',
  );
  const body = new FormData();
  body.append('animationWebp', webpFile);
  body.append('animationVideo', videoFile);

  const response = await fetch(url, {
    method: 'POST',
    body,
    headers: {
      Accept: 'application/json',
      'AMP-User-Id': lodashGet(store.getState(), 'authentication.userData._id', 'dashboard'),
    },
    credentials: 'include',
  });

  return handleResponse(response);
};
